import { render, staticRenderFns } from "./SubjectWrapper.vue?vue&type=template&id=379c6c41"
import script from "./SubjectWrapper.vue?vue&type=script&lang=js"
export * from "./SubjectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports